import { postApiGalaxyServer } from 'services';

// Empty body: the browser sends the httpOnly refresh cookie.
export const logoutApi = ({ token, config = {} }: BaseApiParams<void>) =>
  postApiGalaxyServer<Record<string, never>, void>('/auth/logout', {}, config, token);
